export default {
	title: "Méthodes de paiement",
	tips: "Cher utilisateur, veuillez indiquer votre adresse USDC-ERC20/USDT-TRC20. N'entrez pas vos coordonnées bancaires ni votre mot de passe",
	form: {
		TransactionPassword: "Mot de passe de transaction",
		Address: "Adresse du portefeuille"
	},
	label: [
		"Nom de la banque",
		"Code de la succursale",
		"Nom de la succursale",
		"Type de dépôt",
		"Numéro de compte",
		"Titulaire du compte"
	],
	tabs: ["Carte Bancaire", "Réseau"],
	delete: "Supprimer",
	default: "Défaut",
	create: "Créer",
	type: "Type de retrait",
	verifying: "vérification en cours",
	VerifyWalletAddress: "Vérifier l’adresse du portefeuille",
	defaultAccount: "Compte de retrait par défaut",
	deleteMsg: "Etes-vous sûr que vous voulez supprimer?"
};
